// extracted by mini-css-extract-plugin
export default {"fields":"NewForm_fields__mgEI3","inputTotalSuffix":"NewForm_inputTotalSuffix__vKKKu"};